import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IHeaderResponsivenessOptions } from 'app/shared/models/header-display-options';
import { UserPreferencesService } from 'app/shared/services-api-central/user-preferences/user-preferences.service';
import { LanguageService } from 'app/shared/services/language/language.service';
import moment from 'moment';
import { ReplaySubject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-language-switch',
    templateUrl: './language-switch.component.html',
    styleUrls: ['./language-switch.component.scss'],
    standalone: false
})
export class LanguageSwitchComponent implements OnInit, OnDestroy {

  @Input() headerResponsivenessOptions: IHeaderResponsivenessOptions;

  public label: string;
  public options: Array<string>;
  private unsubscriber = new ReplaySubject();

  constructor(
    private translateService: TranslateService,
    private userPreferencesService: UserPreferencesService,
    private languageService: LanguageService,
  ) {}

  public ngOnInit(): void {
    this.options = this.translateService.getLangs().map((el) => el.toUpperCase());

    this.userPreferencesService.getUserPreferencesLoaded()
      .pipe(
        filter((loaded) => loaded === true),
        takeUntil(this.unsubscriber)
      )
      .subscribe(() => {
        const storedLang = this.userPreferencesService.language;
        if (storedLang !== null) {
          this.label = storedLang.toUpperCase();
        }
      });
  }

  public handleSelectedChanged(event: { index: number, option: string }): void {
    const translatedOption = this.translateService.instant(event.option);
    this.translateService.use(translatedOption.toLowerCase());
    this.userPreferencesService.language = translatedOption.toLowerCase();
    this.label = event.option;
    this.languageService.handleSelectedChanged(event.option.toLowerCase());
    moment.locale(translatedOption.toLowerCase());
  }

  ngOnDestroy() {
    this.unsubscriber.next(true);
    this.unsubscriber.complete();
  }

}
